import './chp1/style';
import FormStructure from './chp1/form_structure';

export default FormStructure;